
import ListComponent from "../../../components/mall_products/Index.vue";

export default {
  components: {
    ListComponent,
  },
};
